import { NavLink } from "react-router-dom";
import { useDemos } from "@/hooks/useDemos";
import { CASE_COPY } from "@/content";
import { formatCount } from "@/lib/format";
import styles from "./CaseRail.module.css";

export function CaseRail() {
  const { data: demos } = useDemos();
  const demosBySlug = new Map((demos ?? []).map((d) => [d.slug, d]));

  return (
    <aside className={styles.rail} data-rail="right">
      <a
        className={styles.back}
        href="https://carlosaltamirano.dev/"
      >
        <span className={styles.backArrow} aria-hidden>←</span>
        <span>Portfolio</span>
      </a>
      <div className={styles.head}>
        <span>Cases</span>
        <small>IV / IV</small>
      </div>

      <div className={styles.cards}>
        {CASE_COPY.map((copy) => {
          const d = demosBySlug.get(copy.slug);
          return (
            <NavLink
              key={copy.slug}
              to={`/dossiers/${copy.slug}`}
              className={({ isActive }) =>
                `${styles.card} ${isActive ? styles.active : ""}`
              }
            >
              <span className={styles.idx}>№{copy.issueNumberRoman}</span>
              <div className={styles.body}>
                <div className={styles.title}>{copy.displayName}</div>
                <div className={styles.domain}>{d?.domain ?? "public dataset"}</div>
                <div className={styles.meta}>
                  <span>{formatCount(d?.n_cases ?? null)} cases</span>
                  <span aria-hidden>·</span>
                  <span>{formatCount(d?.n_events ?? null)} events</span>
                </div>
              </div>
            </NavLink>
          );
        })}
      </div>
    </aside>
  );
}
